// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
/* eslint-disable global-require */
const Cookies = require('cookies-js');
const resolveByCountry = require('@dc/ui-library/src/helpers/environment').resolveByCountry;
const icepick = require('../../node_modules/icepick/icepick.min');

const utils = require('../utils.js');
const initPCWorldClosure = require('../components/react/cookieMessages').default;
const {
  addProductToBasketSilently,
  addProductToBasketSilentlyWithPsa
} = require('../appState/ducks/general');

window.addProductToBasketSilently =
  (fupid, quantity = 1, callback = (_) => _) => window.appState.dispatch(
    addProductToBasketSilently(`${fupid}`)
  ).then(callback);

window.addProductToBasketSilentlyWithPsa =
(fupid, quantity = 1, callback = (_) => _) => window.appState.dispatch(
  addProductToBasketSilentlyWithPsa(`${fupid}`)
).then(callback);

require('../buildInfo');
require('../namespace');
require('../ajax-loader');

// this hides the cookies confirmation popup and black overlay background
// after the loading of the page for the development using browsersync on localhost
// the cookies confirmation popup is injected to the application by 3rd part library in analytics
if (window.location.hostname === 'localhost') {
  const sheet = window.document.styleSheets[0];
  sheet.insertRule('#onetrust-consent-sdk { display: none; }', sheet.cssRules.length);
}

const isCountryIE = resolveByCountry(false, true);
let megaMenu;
let touchMenu;
if (isCountryIE) {
  megaMenu = require('../mega-menu');
  touchMenu = require('../touch-menu');
}

require('../globalEventsHandlers.js')();

const UISettings = require('../utils/UISettings.js');
const UILocale = require('../utils/UILocale.js');
const toggleContents = require('../toggle-contents.js');
const popIn = require('../pop-in.js');
const responsiveElements = require('../responsive-elements.js');
const lazyLoadedImages = require('../components/lazyLoadedImages');
const isitePlayer = require('../isite-player.js');

const ui = require('./ui-global.js');
const { initAddToBasketSilently } = require('./initAddToBasketSilently');

// data layer
const initAppState = require('../appState/index.js').default;
const initDL = require('../dataLayerBootstrap/index.js').default;
const loadSessionStorageState = require('../appState/storePersistence').loadSessionStorageState;

const richRelevanceViewGrid =
  require('../components/native/rich-relevance/richRelevanceViewGrid.js').default;

function initDataLayer() {
  // init old megamenu analytics
  const siteCatalyst = window.s;
  const menuTags = Cookies.get('s_contextData');

  if (menuTags && siteCatalyst) {
    siteCatalyst.contextData = JSON.parse(menuTags);
    Cookies.expire('s_contextData');
  }

  const initialState = { ...window.__initialState__, ...loadSessionStorageState() }; // eslint-disable-line no-underscore-dangle
  const appState = initAppState(icepick.freeze(initialState));
  initDL(
    appState,
    { document: { location: document.location, referrer: document.referrer } }
  );
}

function init() {
  window.DCG.$ = jQuery;

  window.DCG.isitePlayerAPI = isitePlayer;

  // in case of Ireland page, hide some DIVs, if video is not present for the product
  if (resolveByCountry(false, true)) {
    window.DCG.isitePlayerAPI.hideLinkForIrelandOnProductPage();
  }

  // Check for localstorage quote not being exceeded (happens with safari incognito mode)
  window.isLocalStorageWorking = false;
  try {
    localStorage.setItem('foo', 'baa');
    localStorage.removeItem('foo');
    window.isLocalStorageWorking = true;
  } catch (e) {
    console.log(`Local Storage not working:${e}`);
  }

  window.RichRelevanceViewGrid = richRelevanceViewGrid;

  // detect ie10
  if ((document.documentMode !== null) && document.documentMode === 10) {
    document.documentElement.className += ' ie10';
  }

  // Mega Menu
  if (isCountryIE) {
    const desktopNavElt = document.getElementById('desktop-nav');
    if (desktopNavElt) megaMenu(desktopNavElt, desktopNavElt.getAttribute('data-controller'));
    // Touch menu
    touchMenu();
  }

  initDataLayer();

  utils.onDOMLoaded(() => {
    window.App.locale = UILocale.init();
    window.App.settings = UISettings.init();
    ui.DOMReadyInit();
    toggleContents.toggleContents('.toggleControler');
    popIn.initPopInForElements('.popInTrigger');
    // old ms tooltip class to keep for release
    popIn.initPopInForElements('.ms-tooltip');
    responsiveElements.initResponsiveImages();
    responsiveElements.initResponsiveContent();
    lazyLoadedImages();

    initAddToBasketSilently();
  });
}

function initPage(pageInit, initHeader = true) {
  init();
  ui.init(initHeader);
  pageInit.init();
  initPCWorldClosure();
  utils.onDOMLoaded(pageInit.DOMReadyInit);
}

module.exports = {
  initPage: initPage
};
